export default __webpack_public_path__ + "static/Story_Image_1_650x650px-7c2bb868aeaefa2c03c13f4ff4f58add.png";